import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

import { SaneamientoAguaRecord, TableColumns } from '../../models';
import { ImpuestosAguaDesgloseStore } from '../../stores';

import { ImpuestosDesgloseTables, Table, TableNumberCell } from '../shared';
import { SubformSaveButton } from '../shared/SubformSaveButton';
import { TextBlock } from '../shared/TextBlock';

interface DesgloseSubformProps {
    isReadonly: boolean;
    impuestosAguaIngresosStore?: ImpuestosAguaDesgloseStore;
    impuestosAguaDescuentosStore?: ImpuestosAguaDesgloseStore;
}

export const DesgloseSubformWithStore = (
    storeName: 'impuestosAguaIngresosStore' | 'impuestosAguaDescuentosStore'
) => {
    class DesgloseSubfrom extends Component<DesgloseSubformProps> {
        generateSaneamientoColumns = (ejercicio: number): TableColumns<SaneamientoAguaRecord> => [
            {
                title: <TextBlock text="CONCEPTO" />,
                dataIndex: 'concepto'
            },
            {
                title: <TextBlock text="IMPORTE\n(PESOS)" />,
                children: [
                    {
                        title: <TextBlock text={`${ejercicio}\\n(A)`} />,
                        dataIndex: 'saneamiento',
                        width: 250,
                        render: (_, record) => this.renderSaneamientoEjercicio(record.saneamiento)
                    },
                    {
                        title: <TextBlock text={`EJERCICIOS ANTERIORES A ${ejercicio}\\n(B)`} />,
                        dataIndex: 'saneamientoAnterior',
                        width: 250,
                        render: (_, record) =>
                            this.renderSaneamientoEjercicioAnterior(record.saneamientoAnterior)
                    },
                    {
                        title: <TextBlock text="TOTAL\n(C=A+B)" />,
                        dataIndex: 'numeroDeSaneamientoAcumulado',
                        width: 250,
                        render: (_, record) => (
                            <TableNumberCell
                                type="decimal"
                                isReadonly={true}
                                value={record.numeroDeSaneamientoAcumulado}
                            />
                        )
                    }
                ]
            }
        ];

        renderSaneamiento = (handleChange: (path: string, value: number) => void) => (
            value: number
        ) => (
            <TableNumberCell
                type="decimal"
                isReadonly={this.props.isReadonly}
                path="saneamiento"
                value={value}
                onChange={handleChange}
            />
        );

        renderSaneamientoEjercicio = (value: number) =>
            this.renderSaneamiento(this.props[storeName]!.setDesgloseEjercicioValue)(value);

        renderSaneamientoEjercicioAnterior = (value: number) =>
            this.renderSaneamiento(this.props[storeName]!.setDesgloseEjercicioAnteriorValue)(value);

        render() {
            const { isReadonly, [storeName]: store } = this.props;
            const {
                isSaving,
                isLoading,
                ejercicio,
                desgloseEjercicioRecords,
                desgloseEjercicioAnteriorRecords,
                desgloseTotalRecords,
                saneamientoRecords,
                saveDesglose,
                setDesgloseEjercicioValue,
                setDesgloseEjercicioAnteriorValue
            } = store!;

            const description =
                storeName === 'impuestosAguaIngresosStore'
                    ? 'DERECHOS POR SUMINISTRO DE AGUA\\nINGRESOS'
                    : 'DERECHOS POR SUMINISTRO DE AGUA\\nDESCUENTOS, SUBSIDIOS, SUBVENCIONES O BONIFICACIONES';

            return (
                <>
                    <ImpuestosDesgloseTables
                        ejercicio={ejercicio}
                        isReadonly={isReadonly}
                        isLoading={isLoading}
                        description={description}
                        desgloseEjercicioRecords={desgloseEjercicioRecords}
                        desgloseEjercicioAnteriorRecords={desgloseEjercicioAnteriorRecords}
                        desgloseTotalRecords={desgloseTotalRecords}
                        onUpdateEjercicioRecord={setDesgloseEjercicioValue}
                        onUpdateEjercicioAnteriorRecord={setDesgloseEjercicioAnteriorValue}
                    />
                    <TextBlock text="DATOS ESTADÍSTICOS E INFORMATIVOS\nSANEAMIENTO\nDESCUENTOS, SUBSIDIOS, SUBVENCIONES O BONIFICACIONES" />
                    <Table
                        dataSource={saneamientoRecords}
                        columns={this.generateSaneamientoColumns(ejercicio)}
                        loading={isLoading}
                    />

                    {!isReadonly && <SubformSaveButton isSaving={isSaving} onSave={saveDesglose} />}
                </>
            );
        }
    }

    return inject(storeName)(observer(DesgloseSubfrom));
};
